import { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'

import styles from './SectionTitle.module.scss'

type SectionTitleProps = ComponentPropsWithoutRef<'h2'> & {
  as?: 'h1' | 'h2'
}

const SectionTitle = ({
  as: Component = 'h2',
  className,
  ...props
}: SectionTitleProps) => (
  <Component className={clsx(styles.sectionTitle, className)} {...props} />
)

export default SectionTitle
